// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3i34r","inputWrap":"Table_inputWrap__2Rrxg","col":"Table_col__1s2s0","bmiTooltip":"Table_bmiTooltip__1Wq3K"};